import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const usePMAuth = (email) => {
  const [isPMUser, setIsPMUser] = useState(false);
  const [isPMAdmin, setIsPMAdmin] = useState(false);

  const { user } = useAuth0();

  useEffect(() => {
    if (user && user['https://accounts.ikea.com/groups']) {
      if (user['https://accounts.ikea.com/groups']?.includes('IAM_AAD_Aiops-POWERMNT')) {
        setIsPMUser(true);
      } else {
        setIsPMUser(false);
      }
    } else {
      setIsPMUser(false);
    }
    if (user && user['https://accounts.ikea.com/groups']) {
      if (user['https://accounts.ikea.com/groups']?.includes('IAM_AAD_Aiops-POWERMNT-admin')) {
        setIsPMAdmin(true);
      } else {
        setIsPMAdmin(false);
      }
    } else {
      setIsPMAdmin(false);
    }
  }, [user]);

  return [isPMUser, isPMAdmin];
};

export default usePMAuth;
